import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-create-delivery-note',
  templateUrl: 'create.delivery.note.component.html'
})
export class CreateDeliveryNoteComponent implements OnInit {

  deliveryForm: FormGroup;
  plannedDelivery: ProleisObject;
  count: number;

  constructor(private bottomSheetRef: MatBottomSheetRef<CreateDeliveryNoteComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data) {

  }

  ngOnInit() {
    this.plannedDelivery = this.data.delivery;
    this.deliveryForm = new FormGroup({
      deliveryNr: new FormControl(this.plannedDelivery.DELIVERYNOTE_NR, [Validators.required]),
      plannedCount: new FormControl(this.plannedDelivery.PLANNED_COUNT, [Validators.required]),
      plannedDate: new FormControl(this.plannedDelivery.PLANNED_DATE, [Validators.required]),
      deliveryCommentControl: new FormControl(this.plannedDelivery.DELIVERYNOTE_COMMENT),
      replacement: new FormControl(this.plannedDelivery.FREE_REP_DELIVERY)
    });
  }

  submit() {
    this.bottomSheetRef.dismiss({
      replacement: this.deliveryForm.get('replacement').value,
      deliveryNr: this.deliveryForm.get('deliveryNr').value,
      count: this.deliveryForm.get('plannedCount').value,
      date: this.deliveryForm.get('plannedDate').value,
      deliveryComment: this.deliveryForm.get('deliveryCommentControl').value,
      plannedDelivery: this.plannedDelivery.PLANNED_DELIVERY_ID
    });
  }

  dismiss() {
    this.bottomSheetRef.dismiss();
  }

}
